<form [formGroup]="form" (submit)="save.emit(form.value)">
    <lib-form-inputs [filter]="form.filter" [controls]="$any(form).controls" [form]="form"></lib-form-inputs>

    <div class="d-flex justify-content-end">
        @if (showFooter() && showClearButton()) {
        <p-button
            (click)="resetForm()"
            [outlined]="true"
            severity="secondary"
            [label]="$any(form).footer.clear.text | translate"
        >
        </p-button>
        } @if (showFooter()) {
        <p-button class="ms-2" [disabled]="!form.valid">
            {{ $any(form).footer.submit.text | translate }}
        </p-button>
        }

        <input #htmlInputSubmit type="submit" style="display: none" />
    </div>
</form>
